import React from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import css from "./RecipeForMultiform.module.css";
import { getConfig } from "../../config";

const RecipeForMultiform = () => {
  const { t } = useTranslation();
  const { cityCode } = getConfig();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={css.wrap}>
      {errors.recipeEn && (
        <p className={css.error}>{errors.recipeEn.message}</p>
      )}
      <div className={css.inputGroup}>
        <label htmlFor="recipeEn">{t("recipe")} (English)</label>
        <input
          type="text"
          id="recipeEn"
          {...register("recipeEn", {
            required: "Recipe (English) is required",
          })}
          className={errors.recipeEn ? css.inputError : ""}
        />
      </div>

      {errors.recipeRu && (
        <p className={css.error}>{errors.recipeRu.message}</p>
      )}
      <div className={css.inputGroup}>
        <label htmlFor="recipeRu">{t("recipe")} (Русский)</label>
        <input
          type="text"
          id="recipeRu"
          {...register("recipeRu", {
            required: "Recipe (Русский) is required",
          })}
          className={errors.recipeRu ? css.inputError : ""}
        />
      </div>

      {cityCode === "UAE" ? (
        <>
          {errors.recipeAr && (
            <p className={css.error}>{errors.recipeAr.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="recipeAr">{t("recipe")} (العربية)</label>
            <input
              type="text"
              id="recipeAr"
              {...register("recipeAr", {
                required: "Recipe (العربية) is required",
              })}
              className={errors.recipeAr ? css.inputError : ""}
            />
          </div>
        </>
      ) : (
        <>
          {errors.recipeGe && (
            <p className={css.error}>{errors.recipeGe.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="recipeGe">{t("recipe")} (ქართული)</label>
            <input
              type="text"
              id="recipeGe"
              {...register("recipeGe", {
                required: "Recipe (ქართული) is required",
              })}
              className={errors.recipeGe ? css.inputError : ""}
            />
          </div>
        </>
      )}
    </div>
  );
};

export { RecipeForMultiform };
